import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

type Props = {}
export const EngineModels = (props: Props) => (
  <FilterAutocomplete
    label="Engine Models"
    fieldName={'engineModels'}
    fieldPath={'productInformation.engineModels'}
  />
)
